import validate from "/vercel/path0/node_modules/nuxt/dist/pages/runtime/validate.js";
import auth_45global from "/vercel/path0/apps/web/middleware/auth.global.ts";
import manifest_45route_45rule from "/vercel/path0/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  auth_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {
  deckmatchuser: () => import("/vercel/path0/apps/web/middleware/deckmatchuser.ts"),
  "is-staging": () => import("/vercel/path0/apps/web/middleware/isStaging.ts")
}